'use client';

import ReactDOMServer from 'react-dom/server';

export function useSvgAsURL(svg: React.JSX.Element) {
  const svgElement = ReactDOMServer.renderToString(svg);
  const base64Svg = btoa(svgElement);
  return `url(data:image/svg+xml;charset=UTF-8;base64,${base64Svg})`;
}
